"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _raven_client = require("../legacy/helpers/raven_client");

var _raven_client2 = _interopRequireDefault(_raven_client);

var _omitBy = require("lodash/omitBy");

var _omitBy2 = _interopRequireDefault(_omitBy);

var _pickBy = require("lodash/pickBy");

var _pickBy2 = _interopRequireDefault(_pickBy);

var _ravenForRedux = require("raven-for-redux");

var _ravenForRedux2 = _interopRequireDefault(_ravenForRedux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// These action types will not be added to breadcrumbs, since they would clutter the logs
/**
 * Exports a Redux middleware that logs actions & store state to Sentry.
 *
 */

var breadcrumbActionBlacklist = [];

/**
 * Whitelist known small pieces of state
 */
var stateTransformer = function stateTransformer(state) {
	return (0, _pickBy2.default)(state, function (v, k) {
		return ["plugin", "search", "user", "apiResponse", "stripe", "download", "experiments"].includes(k);
	});
};
/**
 * Filters out some of the larger pieces of actions
 */
var actionTransformer = function actionTransformer(actions) {
	return (0, _omitBy2.default)(actions, function (v, k) {
		return ["icons", "response", "asyncDispatch"].includes(k);
	});
};
var filterBreadcrumbActions = function filterBreadcrumbActions(action) {
	return !breadcrumbActionBlacklist.includes(action.type);
};

exports.default = (0, _ravenForRedux2.default)(_raven_client2.default, {
	stateTransformer: stateTransformer,
	actionTransformer: actionTransformer,
	filterBreadcrumbActions: filterBreadcrumbActions
});